import { render, staticRenderFns } from "./RedesPreferenciadas.vue?vue&type=template&id=28eb5bc2&scoped=true"
import script from "./RedesPreferenciadas.vue?vue&type=script&lang=js"
export * from "./RedesPreferenciadas.vue?vue&type=script&lang=js"
import style0 from "./RedesPreferenciadas.vue?vue&type=style&index=0&id=28eb5bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb5bc2",
  null
  
)

export default component.exports